/**
 * PDF page status
 */
export enum EPDFPageStatus {
  EQUAL = 'equal',
  CHANGED = 'changed',
  INSERTED = 'inserted',
  DELETED = 'deleted',
}
